import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import R from 'ramda';
import OptionalSection from '@cotyorg/ccx-utils/js/components/OptionalSection';
import StandardLayout from '../../templates/StandardLayout';
import { HeaderSection } from './Sections/Header';
import { CyberbullyingStoriesSection } from './Sections/CyberbullyingStories';
import { RealStoriesSection } from './Sections/RealStories';
import { FullStoriesSection } from './Sections/FullStories';
import { PartnershipSection } from './Sections/Partnership';
import { InvolvedSection } from './Sections/Involved';
import { TalkSection } from './Sections/Talk';
import { StudySection } from './Sections/Study';
import { BehindTheScenesSection } from './Sections/BehindTheScenes';
import { GroupPhotoSection } from './Sections/GroupPhoto';

const Cyberbullying = ({
  partnership,
  sectionHeadings,
  images,
  videos,
  links,
  buttons,
  showNewsletter,
}) => (
  <StandardLayout>
    <div className="cyberbullying">
      <HeaderSection
        images={R.prop('header', images)}
        videos={R.prop('header', videos)}
        sectionHeading={R.prop('header', sectionHeadings)}
      />

      <CyberbullyingStoriesSection />

      <RealStoriesSection
        sectionHeading={R.prop('realStories', sectionHeadings)}
      />

      <FullStoriesSection
        sectionHeading={R.prop('fullStories', sectionHeadings)}
        videos={R.prop('fullStories', videos)}
      />

      <PartnershipSection
        link={R.prop('partnership', links)}
        images={R.prop('partnership', images)}
        sectionHeading={R.prop('partnership', sectionHeadings)}
        newsletter={R.prop('newsletter', partnership)}
        showNewsletter={showNewsletter}
      />

      <InvolvedSection sectionHeading={R.prop('involved', sectionHeadings)} />

      <OptionalSection
        renderCondition={R.path(['talk', 'heading'], sectionHeadings)}
        section={() => (
          <TalkSection
            sectionHeading={R.prop('talk', sectionHeadings)}
            videos={R.prop('talk', videos)}
          />
        )}
      />

      <OptionalSection
        renderCondition={R.path(['study', 'heading'], sectionHeadings)}
        section={() => (
          <StudySection
            sectionHeading={R.prop('study', sectionHeadings)}
            link={R.prop('study', links)}
            button={R.prop('study', buttons)}
          />
        )}
      />

      <BehindTheScenesSection
        sectionHeading={R.prop('behindTheScenes', sectionHeadings)}
        videos={R.prop('behindTheScenes', videos)}
      />

      <GroupPhotoSection
        sectionHeading={R.prop('groupPhoto', sectionHeadings)}
        images={R.prop('groupPhoto', images)}
      />
    </div>
  </StandardLayout>
);

Cyberbullying.propTypes = {
  partnership: PropTypes.objectOf(PropTypes.object),
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
  images: PropTypes.objectOf(PropTypes.object),
  videos: PropTypes.objectOf(PropTypes.object),
  links: PropTypes.objectOf(PropTypes.object),
  buttons: PropTypes.objectOf(PropTypes.object),
  showNewsletter: PropTypes.bool.isRequired,
};

export default connect(({ content }) => ({
  partnership: R.prop('partnership', content),
  sectionHeadings: R.prop('sectionHeadings', content),
  images: R.prop('images', content),
  videos: R.prop('videos', content),
  links: R.prop('links', content),
  buttons: R.prop('buttons', content),
  showNewsletter: R.path(['newsletter', 'submitButtonText'], content),
}))(Cyberbullying);
